import dayjs from '$/utils/dayjs/index.ts';
import type { TripData } from '$/models/Trip.model.ts';

export type StayDates = { checkIn: string; checkOut: string };

export type Party = { adults: number; childAges: number[] };

const DATE_FORMAT = 'YYYY-MM-DD';

export const stayDates = (
  arrivalDate: string | null | undefined,
  checkInDay: number,
  checkOutDay: number,
  today: string
): StayDates | null => {
  if (!arrivalDate || checkOutDay <= checkInDay) return null;

  const arrival = dayjs.utc(arrivalDate);

  if (!arrival.isValid()) return null;

  const checkIn = arrival.add(checkInDay - 1, 'day').format(DATE_FORMAT);

  if (checkIn < today) return null;

  return { checkIn, checkOut: arrival.add(checkOutDay - 1, 'day').format(DATE_FORMAT) };
};

export const partyOf = (trip: Pick<TripData, 'number_of_adults' | 'children_ages'> | null | undefined): Party => ({
  adults: Math.max(1, Math.floor(trip?.number_of_adults ?? 1)),
  childAges: (trip?.children_ages ?? []).map((age) => Math.max(0, Math.floor(age))),
});
